// Define projects using the component loader
const availableProjectLoaders = []
if (window.Sanitas?.dotcom) {
  availableProjectLoaders.push('dotcom')
}
if (window.Sanitas?.dvp) {
  availableProjectLoaders.push('dvp')
}

// Find components in a tree based on the project name using the attribute name convention `data-PROJECTNAME-component`
const findComponents = (node, projectName) => {
  let list = []
  const datasetName = `${projectName}Component`
  const attributeName = `data-${projectName}-component`
  if (node.dataset && node.dataset[datasetName]) {
    list.push(node.dataset[datasetName])
  }
  // Find components in subtree
  if (
    typeof node.querySelector === 'function' &&
    node.querySelector(`[${attributeName}]`)
  ) {
    node.querySelectorAll(`[${attributeName}]`).forEach(component => {
      list = list.concat(findComponents(component, projectName))
    })
  }
  return list
}

// Logic to load a component based on an existing render function or by loading needed asset chunks
const loadComponent = (name, data) => {
  if (!data) {
    console.log('component loader: data is undefined', name)
    return
  }

  if (data.instances && data.instances[name]) {
    console.info('component loader: render function', name)
    // Call the rendering function if another instance of the component was initialised before
    data.instances[name]()
  } else if (data.dynamicAssets[name]) {
    console.info('component loader: dynamic assets', name)
    // Load needed js dependencies
    data.dynamicAssets[name].js.forEach(jsItem => {
      const injectScript = document.createElement('script')
      injectScript.src = jsItem
      document.getElementsByTagName('head')[0].appendChild(injectScript)
    })
    // Load needed css dependencies
    data.dynamicAssets[name].css.forEach(cssItem => {
      const injectLink = document.createElement('link')
      injectLink.href = cssItem
      document.getElementsByTagName('head')[0].appendChild(injectLink)
    })
  } else {
    console.log('component loader: component not in dynamicAssets', name)
  }
}

// Initialise new observer to handle added nodes
const observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (mutation.type === 'childList') {
      if (!mutation.addedNodes.length) return

      availableProjectLoaders.forEach(project => {
        let projectComponents = []

        mutation.addedNodes.forEach(node => {
          const addedComponents = findComponents(node, project)
          projectComponents = projectComponents.concat(addedComponents)
        })

        const uniqueProjectComponents = [...new Set(projectComponents)]
        uniqueProjectComponents.forEach(componentName => {
          loadComponent(componentName, window.Sanitas[project])
        })
      })
    }
  })
})

// Initialise observer on the body for added dom nodes
const target = document.querySelector('body')
observer.observe(target, {
  attributes: false,
  childList: true,
  characterData: false,
  subtree: true,
})

// Feature toggle for initial component loading in extension to mutation observer loading
if (document.body.classList.contains('dotcom-component-loader')) {
  const components = document.querySelectorAll('[data-dotcom-component]')
  components.forEach(async item => {
    const componentName = item.dataset?.dotcomComponent
    loadComponent(componentName, window.Sanitas.dotcom)
  })
}
